<template>
  <article class="benefit-message">
    <section>
      <slot></slot>
    </section>
  </article>
</template>

<script>

export default {
  data () {
    return {
    }
  },
	components: {
	}
}
</script>

<style scoped lang="scss">
.benefit-message {
  font-size: 20px;
  font-weight: bold;
  display: flex;align-items: center;
  max-width: 960px;
  width: 100%;
  border-radius: 24px;
  color: #ffffff;
  background: -moz-linear-gradient(left, #D70370, #A81FF8);
  background: -webkit-linear-gradient(left, #D70370, #A81FF8);
  background: linear-gradient(to right, #D70370, #A81FF8);
  padding: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/GradationMessage.vue